import { ReactNode, useContext } from 'react'
import styled from '@emotion/styled'
import { useRouterState } from '@tanstack/react-router'
import * as Sentry from '@sentry/react'

import AppHeader from './AppHeader'
import { Flex } from './Flex'
import SideBar from './Sidebar'
import { Message } from './Message'
import { Button } from './Button'

import { SIDEBAR_CONFIG } from '@/constants/sideBarConfig'
import { mediaQuery } from '@/utils/mediaQuery'
import { findChild } from '@/utils/subMenu'
import { AuthContext } from '@/features/Auth/application/AuthContext'
import { CrossIcon } from '@/assets/icons'
import { colors } from '@/constants'

const Panel = styled.div<{ fullWidth?: boolean }>`
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  /* Without this the panel widens to its widest content instead of to the
     viewport, and the sticky header widens with it — pushing the profile
     menu off the right edge. */
  min-width: 0;
`

const Content = styled(Flex)`
  flex-grow: 1;
  min-width: 0;

  /* ${mediaQuery('md')} {
    width: 100dvw;

  } */

  ${mediaQuery('sm')} {
    width: 100dvw;
  }
`

export const Layout = ({ children }: { children?: ReactNode }) => {
  const { authStatus } = useContext(AuthContext)
  const location = useRouterState({ select: (s) => s.location.pathname })

  const signedIn = authStatus === 'signedIn'
  const current = findChild(location, SIDEBAR_CONFIG)

  return (
    <Flex width="100%" height="100%">
      {signedIn && <SideBar title={current?.label} config={SIDEBAR_CONFIG} />}
      <Panel fullWidth={!signedIn}>
        <AppHeader routeConfig={current} location={location} />
        <Content>
          <Sentry.ErrorBoundary
            fallback={({ error, resetError }) => {
              const errorMessage =
                error instanceof Error
                  ? error.message
                  : 'An unexpected error occurred'
              return (
                <Message
                  icon={<CrossIcon fill={colors.red} width={40} height={40} />}
                  title="Something went wrong"
                  description={errorMessage}
                >
                  <Button onClick={resetError} style={{ marginTop: '1rem' }}>
                    Try again
                  </Button>
                </Message>
              )
            }}
            showDialog
          >
            {children}
          </Sentry.ErrorBoundary>
        </Content>
      </Panel>
    </Flex>
  )
}
